import styled from '../../../../../../../styles/styledComponents/themeComponents';

export const RelatedTagModalStyle = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;
